'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _timeUtil = require('../../common/utils/timeUtil');

var _notificationConstants = require('./notificationConstants');

var _userConstants = require('../../common/users/userConstants');

var _notificationConstants2 = require('../../common/notifications/notificationConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.fromJS({
    fetched: false,
    fetchedTime: null,
    forcedPoll: null,
    modifiedElements: {}
});

var updateNotificationSeen = function updateNotificationSeen(state, action) {
    if (!state.getIn(['modifiedElements', action.previousBoardId])) return state;

    return state.setIn(['modifiedElements', action.previousBoardId, 'viewedBoard'], action.timestamp);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _notificationConstants.MODIFIED_ELEMENTS_SET:
            return state.set('modifiedElements', Immutable.fromJS(action.modifiedElements)).set('fetchedTime', (0, _timeUtil.getTimestamp)()).set('fetched', true);
        case _notificationConstants.MODIFIED_ELEMENTS_ADD:
            return state.mergeDeepIn(['modifiedElements'], action.modifiedElements).set('fetchedTime', (0, _timeUtil.getTimestamp)()).set('fetched', true);
        case _userConstants.USER_NAVIGATE:
            return updateNotificationSeen(state, action);
        case _notificationConstants2.MODIFIED_ELEMENTS_FORCE_POLL:
            return state.set('forcedPoll', action.timestamp);
        case _notificationConstants.MODIFIED_ELEMENTS_ERROR:
            return state.set('fetched', true);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/notifications/notificationsReducer.js
// module id = 2037
// module chunks = 0